<form [formGroup]="vendaForm" class="forms">
  <div class="row">
    <div class="row info-container white-box">
      <h2>Média mensal de vendas</h2>
      <div class="form-group">
        <span class="icon happy"></span>
        <div class="inputs">
          <label for="valorMesBom">Valor médio bom
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Valor médio de vendas nos meses que têm conceito BOM.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="valorMesBom"
            formControlName="valorMesBom"
            maxlength="17"
            minlength="3"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon so-so"></span>
        <div class="inputs">
          <label for="valorMesRegular">Valor médio regular
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Valor médio de vendas nos meses que têm conceito REGULAR.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="valorMesRegular"
            formControlName="valorMesRegular"
            maxlength="17"
            minlength="3"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon sad"></span>
        <div class="inputs">
          <label for="valorMesRuim">Valor médio ruim
            <saiba-mais
            [isPopoverOnHover]="true"
            [isPositionStatic]="true"
            [isSmall]="true"
            [titulo]="'Ajuda'"
            [texto]="'Valor médio de vendas nos meses que têm conceito FRACO.'"></saiba-mais>
          </label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="valorMesRuim"
            formControlName="valorMesRuim"
            maxlength="17"
            minlength="3"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>

      <h2>Meses em que ocorrem as vendas
        <saiba-mais
        [isPopoverOnHover]="true"
        [isPositionStatic]="true"
        [isSmall]="true"
        [titulo]="'Ajuda'"
        [texto]="'Marcar pelo menos um mês para cada conceito.'"
        style="float: none;"></saiba-mais>
      </h2>
      <div class="form-group meses">
        <div class="mes" *ngFor="let form of mediasMes.controls; index as i" [formGroup]="form">
          <label>{{ descricaoMeses[form.get('mes').value - 1]}}</label>
          <app-emotion-select formControlName="tipoMes">
            <app-emotion-select-item [value]="'1'" [emotion]="'very-happy'"></app-emotion-select-item>
            <app-emotion-select-item [value]="'2'" [emotion]="'so-so'"></app-emotion-select-item>
            <app-emotion-select-item [value]="'3'" [emotion]="'sad'"></app-emotion-select-item>
          </app-emotion-select>
        </div>
      </div>
    </div>
  </div>
</form>
<app-botao-navegacao
(previous)="onClickPrevious()"
(next)="onClickNext()"
[previousShow]="true"
[nextShow]="true"
[nextEnabled]="vendaForm.valid && selectedMinSixType">
</app-botao-navegacao>
